import { useState } from "react";
import ApiFetch from "../../services/api.fetch";
import { URLS } from "../../utils/url";
import { DataByIdValues } from "../interfaces/ApiInterface";

export const useCollection = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({
    message: "",
    status: false,
  });

  const getDataById = async (
    id: number | string,
  ): Promise<any | null | undefined> => {
    try {
      const data = await ApiFetch.httpGetPublic(
        URLS.get.collection.getPublicCollectionByPropertyId.id(id),
      );

      setData(data);
      return data;
    } catch (err) {
      setError({
        status: true,
        message: "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  //   const getPropertyBySlug = async (
  //     slug: string,
  //   ): Promise<any | null | undefined> => {
  //     try {
  //       const data = await ApiFetch.httpGetPublic(
  //         URLS.get.property.getPublicPropertyBySlug.slug(slug),
  //       );

  //       setData(data);
  //       return data;
  //     } catch (err) {
  //       setError({
  //         status: true,
  //         message: "Something went wrong",
  //       });
  //       throw new Error(error.message);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const values: any = {
    data,
    error,
    loading,
    setLoading,
    setError,
    getDataById,
    // getPropertyBySlug,
  };

  return values;
};
